:host {
  min-height: 100vh;
  background: var(--color-bg-secondary);
  overflow-x: hidden;
  position: relative;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}
.hidden {
  display: none !important;
}
.header {
  background: var(--color-bg-primary);
  border-bottom: var(--border);
  padding: var(--padding-xl) var(--margin-xl);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-bg-accent);
}
.user-menu {
  display: flex;
  align-items: center;
  gap: var(--margin-xl);
}
.user-name {
  font-weight: var(--font-weight-medium);
}
.profile-btn {
  display: flex;
  align-items: center;
  gap: var(--margin-s);
  padding: var(--padding) var(--padding-xl);
  background: transparent;
  border: var(--border);
  border-radius: var(--border-radius);
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: var(--font-size);
  text-decoration: none;
  transition: all 0.2s ease;
}
.profile-btn:hover {
  background: var(--color-bg-secondary);
  color: var(--color-bg-accent);
}
.profile-btn .icon {
  margin-right: var(--margin);
  width: 20px;
  height: 20px;
}
.profile-text {
  white-space: nowrap;
}
.icon {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.icon svg {
  width: 100%;
  height: 100%;
  fill: var(--color-text-secondary);
}
button .icon svg,
a .icon svg {
  fill: currentColor;
}
.nav-link .icon {
  width: 20px;
  height: 20px;
  margin-right: var(--margin-s);
  vertical-align: text-top;
}
.nav-link.active .icon svg {
  fill: var(--color-text-primary);
}
.theme-toggle-btn {
  padding: var(--padding);
  background: transparent;
  border: var(--border);
  border-radius: var(--border-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.theme-toggle-btn:hover {
  background: var(--color-bg-secondary);
}
.theme-icon {
  width: 20px;
  height: 20px;
  fill: var(--color-text-primary);
}
.logout-btn {
  padding: var(--padding) var(--padding-xl);
  background: transparent;
  border: var(--border);
  border-radius: var(--border-radius);
  cursor: pointer;
  font-size: var(--font-size);
}
.logout-btn:hover {
  background: var(--color-bg-secondary);
}
.main {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--margin-xl);
  gap: var(--margin-xl);
  width: 100%;
}
.sidebar {
  width: 200px;
  flex-shrink: 0;
}
.nav {
  list-style: none;
  padding: 0;
  margin: 0;
}
.nav-item {
  margin-bottom: var(--margin-s);
}
.nav-link {
  display: inline-block;
  width: 100%;
  padding: var(--padding-l) var(--padding-xl);
  border-radius: var(--border-radius);
  cursor: pointer;
  color: var(--color-text-primary);
  text-decoration: none;
  vertical-align: middle;
  box-sizing: border-box;
}
.nav-link:hover {
  background: var(--color-bg-secondary);
}
.nav-link.active {
  background: var(--color-bg-accent);
}
.content {
  flex: 1;
  background: var(--color-bg-primary);
  border: var(--border);
  border-radius: var(--border-radius);
  padding: 0;
}
.notifications-icon {
  position: relative;
  cursor: pointer;
  width: 22px;
  height: 22px;
}
.notification-pip {
  position: absolute;
  display: block;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background: var(--color-danger);
  box-shadow: 0 0 0 3px var(--color-bg-primary);
  border-radius: 100%;
}
.notifications-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  max-width: 90vw;
  height: 100vh;
  background: var(--color-bg-primary);
  border-left: var(--border);
  transform: translateX(100%);
  z-index: 1001;
  overflow-y: auto;
  transition: transform 0.3s ease;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
}
.notifications-sidebar.open {
  transform: translateX(0);
}
.notifications-sidebar .header {
  padding: var(--padding-xl);
  border-bottom: var(--border);
  background: var(--color-bg-secondary);
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notifications-sidebar .header h3 {
  margin: 0;
  font-size: var(--font-size);
  font-weight: var(--font-weight-medium);
}
.notifications-sidebar .close-btn {
  background: none;
  border: none;
  font-size: var(--font-size-l);
  cursor: pointer;
  color: var(--color-text-secondary);
  padding: var(--padding);
  line-height: 1;
}
.notifications-sidebar .close-btn:hover {
  color: var(--color-text-primary);
}
.notifications-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.notifications-list li {
  padding: var(--padding-l);
  border-bottom: var(--border);
  font-size: var(--font-size-l);
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: start;
  gap: var(--padding-m);
  position: relative;
}
.notification-content {
  flex: 1;
}
.notification-delete {
  background: none;
  border: none;
  font-size: var(--font-size-xl);
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: var(--padding-s);
  line-height: 1;
  transition: color 0.2s;
  flex-shrink: 0;
}
.notification-delete:hover {
  color: var(--color-danger);
}
.notifications-list li:last-child {
  border-bottom: none;
}
.notifications-list li:hover {
  background: color-mix(in oklab, var(--color-bg-primary), black 10%);
}
.notifications-list li.greyed-out {
  color: var(--color-text-secondary);
  cursor: default;
  text-align: center;
  padding: var(--padding-xl);
}
.notifications-list li.greyed-out:hover {
  background: transparent;
}
.notifications-list li.unread {
  background: var(--color-bg-tertiary);
  font-weight: var(--font-weight-medium);
}
.notification-title {
  font-weight: var(--font-weight-medium);
  margin-bottom: var(--padding);
}
.notification-message {
  font-size: var(--font-size);
  color: var(--color-text-secondary);
  margin-bottom: var(--padding);
}
.notification-action:hover {
  background-color: var(--color-bg-primary);
  color: var(--color-bg-accent);
}
.mobile-menu-toggle {
  display: none;
}
/* Generic icon button */
.icon-btn {
  background: none;
  border: none;
  padding: var(--padding-s);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius);
  width: 30px;
  height: 30px;
}
.icon-btn:hover {
  background: var(--color-bg-secondary);
}
@media (max-width: 768px) {
  .logo {
    font-size: var(--font-size-l);
  }
  .user-menu {
    font-size: var(--font-size);
  }
  .user-name {
    display: none;
  }
  .profile-btn {
    padding: var(--padding);
    min-width: 40px;
    justify-content: center;
  }
  .profile-text {
    display: none;
  }
  .logout-btn {
    font-size: var(--font-size);
  }
  .mobile-menu-toggle {
    display: flex;
    position: fixed;
    bottom: var(--margin-xl);
    left: var(--margin-xl);
    width: 56px;
    height: 56px;
    background: var(--color-bg-accent);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1000;
    align-items: center;
    justify-content: center;
    box-shadow: var(--box-shadow);
  }
  .menu-icon {
    width: 24px;
    height: 24px;
    position: relative;
  }
  .main {
    flex-direction: row;
    padding: var(--padding-l);
    margin: 0;
    gap: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 65%;
    height: 100vh;
    background: var(--color-bg-primary);
    border-right: var(--border);
    transform: translateX(-100%);
    z-index: 999;
    padding: var(--padding-xl);
    overflow-y: auto;
    transition: transform 0.4s ease;
    box-shadow: none;
  }
  .sidebar.open {
    opacity: 1;
    transform: translateX(0);
    transition: transform 0.4s ease;
    box-shadow: var(--box-shadow);
  }
  .nav {
    display: flex;
    flex-direction: column;
    margin-top: calc(var(--margin-xl) * 2);
  }
  .nav-item {
    margin-bottom: var(--margin-s);
  }
  .nav-link {
    padding: var(--padding-l) var(--padding-xl);
    font-size: var(--font-size);
  }
  .nav-icon {
    filter: unset;
  }
  .content {
    flex: 1;
    padding: 0;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    box-sizing: border-box;
  }
}
